import takeRequest from '~/store/takeRequest';
import { listGenericLogs, sendAuditLog } from '~/store/logs/actions';

export function* logsSaga() {
  yield takeRequest(listGenericLogs);
  yield takeRequest(sendAuditLog);
}
